module.exports = __webpack_public_path__ + "static/hero-bg-mobile-de-71912c0cad282231f4b8c79be69231fb.jpg";